import { HttpResponse } from './IHttpClient'

/**
 * Descreve uma resposta HTTP malsucedida para log.
 *
 * Existe porque `status` **não existe** em falha de transporte (`validateStatus` aceita qualquer
 * status, então uma resposta do servidor nunca cai no catch). Logar `HTTP ${response.status}` nesses
 * casos produzia literalmente `HTTP undefined`. Aqui o `code` do axios entra no lugar.
 */
export function describeHttpFailure(response: HttpResponse): string {
  // `=== false` e obrigatorio, nao estilo: o projeto roda com `strictNullChecks: false`, e nesse modo
  // o TS NAO estreita o union pelo caminho negativo de `if (response.success)`. Verificado.
  if (response.success === false && response.status === undefined) {
    return response.code ?? response.error?.message ?? 'network error'
  }

  return `HTTP ${response.status}`
}
